module.exports = __webpack_public_path__ + "static/media/uværet.f9815dac.mp3";